
/**
 * 콘텐츠 타입
 */
export type CourseSectionLecturesItemContentType = typeof CourseSectionLecturesItemContentType[keyof typeof CourseSectionLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseSectionLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  INTERACTIVE: 'INTERACTIVE',
  QUIZ: 'QUIZ',
} as const;
